var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var ref_item = ref.item;
var id = ref_item.id;
var category = ref_item.category;
var score = ref_item.score;
var self = ref_item.self;
var question = ref_item.question;
var meanScore = ref_item.meanScore;
var diffSelfAndmeanScore = ref_item.diffSelfAndmeanScore;
var sdScore = ref_item.sdScore;
var frequency = ref_item.frequency;
var index = ref.index;
return [_c('tr',[_c('td',[_vm._v(_vm._s(id))]),_c('td',[_vm._v(_vm._s(category))]),_c('td',[_vm._v(_vm._s(question))]),_c('td',[_vm._v(_vm._s(self))]),_c('td',[_vm._v(_vm._s(meanScore))]),_c('td',[_vm._v(_vm._s(diffSelfAndmeanScore))]),_c('td',[_c('ho-bar-chart',{staticClass:"chart1",attrs:{"value":meanScore,"marker":self,"ops":_vm.ops}})],1),_c('td',[_vm._v(_vm._s(sdScore))]),_c('td',[_c('bar-chart',{staticClass:"chart2",attrs:{"values":frequency,"markers":self != undefined ? [self - 1] : []}})],1)])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }